import { graphql } from '../gql'

export const GET_ALERTS_QUERY = graphql(`
  query GetAlerts($path: String!) {
    getAlerts(path: $path) {
      active
      content
      updatedAt
      button {
        label
        linkRef
        openInNewTab
        url
        type
      }
      asset {
        preview
        type
        width
        height
      }
    }
  }
`)
